import Image from "next/image";
import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import styles from "./Service.module.scss";

export default function Service() {
  return (
    <div className={styles.container}>
      <Paragraph
        title="Bạn có thể cho chúng tôi biết thêm về trải nghiệm mà PipFarm mang lại cho các nhà giao dịch không? Trải nghiệm có dễ dàng và nhanh chóng không?"
        content={[
          'Các nhà giao dịch tại PipFarm cảm thấy vô cùng may mắn khi làm việc với một công ty thực sự hỗ trợ họ. Chúng tôi không chỉ cung cấp hỗ trợ mà còn tạo ra một cộng đồng nơi các nhà giao dịch có thể hỗ trợ và động viên nhau, đặc biệt khi cùng chia sẻ niềm vui chiến thắng hay bù đắp tổn thất.',
        ]}
        contentStyle={{ maxWidth: '1081px' }}
      />
      <Paragraph
        title="Theo bạn, điều khó khăn nhất khi mở rộng kinh doanh tại Việt Nam là gì?"
        content={[
          'Thách thức lớn nhất PipFarm phải đối mặt khi gia nhập thị trường Việt Nam là thiếu nhận thức về nền tảng cTrader. Cho đến nay, hầu hết các sàn môi giới hoạt động tại Việt Nam chỉ cung cấp một nền tảng mà hầu hết các nhà giao dịch đã quen thuộc và ngại thay đổi vì họ thích ở trong vùng an toàn.',
          'Khi MetaTrader ngừng hỗ trợ mô hình kinh doanh giao dịch quỹ, chúng tôi đã khảo sát các nhà giao dịch của mình để hiểu cảm nhận của họ. Hơn 50% cho biết họ ưa thích cTrader. Và 55% cho biết chỉ mất một tuần để cảm thấy thoải mái khi giao dịch trên nền tảng mới.',
          'Chúng tôi tin rằng việc giới thiệu cTrader tới các nhà giao dịch forex và quỹ tại Việt Nam sẽ có tác động tích cực đến cộng đồng giao dịch tại đây.',
        ]}
        contentStyle={{ maxWidth: '1090px' }}
      />
      <div className={styles['eli-container']}>
        <Image
          src="/images/landing_page_pipfarm/Ellipse1.png"
          alt="Ellipse Icon"
          width={521}
          height={521}
        />
      </div>
    </div>
  );
}
